module.exports = __webpack_public_path__ + "img/behance.345f5d71.svg";